<template>
    <!--@formatter:off-->
    <div>
        <SurveyQuestionViewer
            :question="questions[0]"
            :is-use-start-question-number="false"
            :question-index="0"
            @changeActiveEditor="onChangeActiveEditor"
        />

        <SurveyQuestionViewerParentCounselWeekTime
            :question="questions[1]"
            :is-use-start-question-number="false"
            :question-index="calcQuestionIndex(1)"
            @changeActiveEditor="onChangeActiveEditor"
        />

        <SurveyQuestionViewer
            :question="questions[2]"
            :is-use-start-question-number="false"
            :question-index="calcQuestionIndex(2)"
            @changeActiveEditor="onChangeActiveEditor"
        />

        <SurveyQuestionViewer
            :question="questions[3]"
            :is-use-start-question-number="false"
            :question-index="calcQuestionIndex(3)"
            @changeActiveEditor="onChangeActiveEditor"
        />
    </div>
    <!--@formatter:on-->
</template>

<script>
import SurveyQuestionViewer from '@iamteacherpc/components/editor/SurveyQuestionViewer.vue';
import SurveyQuestionViewerParentCounselWeekTime
    from '@iamteacherpc/components/editor/SurveyQuestionViewerParentCounselWeekTime.vue';

export default {
    name: "SurveyQuestionViewerParentCounselWeek",
    components: {SurveyQuestionViewerParentCounselWeekTime, SurveyQuestionViewer},

    props: {
        question: {
            type: Object,
            required: true,
        },

        questionIndex: {
            type: Number,
            required: true,
        },
    },

    computed: {
        questions() {
            return this.question.questions;
        },
    },

    methods: {
        onChangeActiveEditor(questionIndex, questionNo) {
            this.$emit('changeActiveEditor', this.questionIndex, questionNo);
        },

        calcQuestionIndex(index) {
            const notUseQuestionCount = this.questions
                .slice(0, index)
                .filter(q => !q.isUseQuestion)
                .length;

            return index - notUseQuestionCount;
        },
    },
}
</script>

<style scoped>

</style>